// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ChatModule.css */
.chat-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #000000;
  font-weight: 500;
  margin: 1rem;
  font-size: 18px;
}

.chat-avatar {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 20px;
}

.chat-avatar-wrapper {
  padding: 1rem;
}

.chat-avatar img {
  width: 80px;
  height: 80px;
  border-radius: 50%;
}

.chat-greeting {
  font-size: 20px;
  font-weight: bold;
  margin-top: 10px;
}

.chat-description {
  color: gray;
  font-size: 16px;
  text-align: center;
  margin-top: 2rem;
}

.swiper-slide {
  padding: 10px;
  background-color: #FFFFFF;
  border: 2px solid #F2F2F2;
  border-radius: 5rem;
  text-align: center;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  color: #000000;
}

/* Chat Input Container */
.chat-input-container {
  position: fixed;
  bottom: 20px;
  left: 20px;
  right: 20px;
}

/* Chat Input Box */
.chat-input {
  height: 6rem;
  width: 100%;
  padding: 12px;
  border-radius: 50px;
  background-color: #e5e7eb;
  border: 2px solid transparent;
  outline: none;
  font-size: 14px;
  transition: all 0.3s ease-in-out;
  padding-left: 4rem;
  padding-right: 8rem;
}

.chat-input::placeholder {
  color: #8B8B8B; /* Gray color */
  font-family: "Outfit";
  font-size: 16px;
}

/* Hover Effect */
.chat-input:hover {
  border: 2px solid #10b981; /* Green Border */
}

/* Input Icon */
.input-icon {
  position: absolute;
  left: 15px; /* Align inside input */
  top: 50%;
  transform: translateY(-50%);
  color: #6b7280; /* Gray color */
  font-size: 18px;
  cursor: pointer;
  transition: color 0.3s ease-in-out;
}

.send-btn {
  position: absolute;
  right: 15px; /* Align inside input */
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
}

.chat-messages {
  overflow-y: auto; /* Enables scrolling */
  padding: 10px;
  max-height: calc(100vh - 120px); /* Adjust based on header and input height */
  scroll-behavior: smooth;
  display: flex;
  flex-direction: column;
}

.scroll-anchor {
  padding-bottom: 80px;
}

.chat-message {
  position: relative;
  padding: 12px 16px;
  border-radius: 8px;
  margin: 8px 0;
  max-width: 70%;
  word-wrap: break-word;
}

.chat-message.user {
  align-self: flex-end;
  background-color: #00AA74;
  color: #FFFFFF;
  text-align: right;
  font-family: "Outfit";
  font-size: 14px;
  border-radius: 25px 25px 2px 25px;
}

.chat-message.bot {
  align-self: flex-start;
  background-color: #F2F2F2;
  color: #1E1E1E;
  text-align: left;
  font-size: 14px;
  font-family: "Outfit";
  width: 500px;
  border-radius: 25px 29px 25px 2px;
}

.station-wrapper {
  position: relative;
  padding: 12px 16px;
  border-radius: 8px;
  margin: 8px 0;
  word-wrap: break-word;
  background-color: #F2F2F2;
}

.station-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 10px;
}

.station-card {
  display: flex;
  background: #fff;
  padding: 10px;
  border-radius: 8px;
  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.1);
  align-items: center;
}

.station-image {
  width: 50px;
  height: 50px;
  border-radius: 5px;
  margin-right: 10px;
}

.station-details {
  flex-grow: 1;
}

.station-heading {
  color: #1E1E1E;
  font-family: "Outfit";
  font-weight: 400;
  font-size: 14px;
  padding-bottom: 1rem;
}

.station-name {
  color: #1E1E1E;
  font-family: "Outfit";
  font-weight: 400;
  font-size: 14px;
  white-space: nowrap;
  padding-bottom: 1rem;
  padding-right: 1rem;
}

.station-session {
  color: #8C8C8C;
  font-family: "Outfit";
  font-weight: 400;
  font-size: 12px;
  padding-right: 2rem;
}

.selected-station-session {
  color: #8C8C8C;
  font-family: "Outfit";
  font-weight: 400;
  font-size: 12px;
  padding-right: 3rem;
}

.station-rating {
  background: green;
  color: white;
  padding: 3px 6px;
  border-radius: 4px;
  font-size: 12px;
}

.payment-container {
  background: #f5f5f5;
  border-radius: 12px;
}

.payment-container {
  margin-bottom: 20px;
}

.payment-card {
  margin-bottom: 16px;
}

.refund-ids-container {
  width: 100%;
}

.refund-id-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
  padding: 8px;
  background-color: #f5f5f5;
  border-radius: 4px;
  margin-top: 5px;
}

.refund-id {
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis;
  flex: 1;
}

.copy-icon {
  margin-left: 10px;
  cursor: pointer;
  width: 18px;
  height: 18px;
}

.copy-icon:hover {
  opacity: 0.7;
}

.payment-header {
  background-color: #F2F2F2;
  color: #1E1E1E;
  text-align: left;
  font-size: 14px;
  font-family: "Outfit";
  margin-bottom: 16px;
}

.payment-card {
  background: white;
  border-radius: 12px;
  padding: 15px;
  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.1);
  text-align: center;
  padding-bottom: 1rem;
}

.payment-title {
  font-size: 14px;
  color: #8C8C8C;
  margin-bottom: 11px;
  font-family: "Syne";
  font-weight: 700;
  font-size: 14px;
}

.payment-amount {
  font-size: 24px;
  font-weight: 500;
  margin-bottom: 14px;
  color: #1E1E1E;
  font-family: "Outfit";
}

.payment-button {
  height: 39px;
}

.payment-button:hover {
  opacity: 0.9;
}

.refund-info {
  padding-top: 1rem;
  padding-bottom: 1rem;
}

.chat-actions {
  display: flex;
  gap: 8px;
  margin-top: 5px;
}
.chat-actions .icon {
  font-size: 14px;
  cursor: pointer;
  color: gray;
}
.chat-actions .icon:hover {
  color: black;
}

.selected-text {
  font-size: 14px;
  color: #FFFFFF;
  margin-top: 5px;
  text-align: right;
  font-family: "Outfit";
  font-size: 400;
}

.liked {
  filter: invert(48%) sepia(79%) saturate(2476%) hue-rotate(86deg) brightness(90%) contrast(85%);
}

.disliked {
  filter: invert(27%) sepia(51%) saturate(7471%) hue-rotate(356deg) brightness(97%) contrast(115%);
}

.bot-button-wrapper {
  width: 100%;
  display: flex;
  justify-content: center;
}

.bot-button {
  background-color: #F2F2F2;
  color: #1E1E1E;
  font-size: 14px;
  font-family: "Outfit";
  width: 80%;
  border-radius: 25px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  margin-top: 10px;
  padding-bottom: 16px;
}

.button-card {
  display: flex;
  background: #fff;
  padding: 10px;
  border-radius: 8px;
  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.1);
  align-items: center;
  width: 85%;
}

.button-heading {
  color: #1E1E1E;
  font-family: "Outfit";
  font-weight: 500;
  font-size: 18px;
  padding-bottom: 1rem;
  padding-top: 2rem;
  padding-right: 2rem;
}

.bot-button-image {
  background-color: #F2F2F2;
  width: 31px;
  height: 31px;
  border-radius: 5px;
  margin-right: 10px;
  padding: 6px;
}
.bot-button-image img {
  object-fit: contain;
}

.bot-button-name {
  color: #1E1E1E;
  font-family: "Outfit";
  font-weight: 500;
  font-size: 14px;
  white-space: nowrap;
  padding-bottom: 1rem;
  padding-right: 1rem;
}

/* Chat Input Container */
.swiper-container {
  position: fixed;
  bottom: 99px;
  left: 2px;
  right: 20px;
}

.swiper-slide.swiper-style {
  height: auto;
  display: flex;
  align-items: center;
  justify-content: center;
}

.show-bot-button {
  background-color: #F2F2F2;
  color: #1E1E1E;
  font-size: 14px;
  font-family: "Outfit";
  width: 80%;
  border-radius: 25px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  margin-top: 10px;
  padding-bottom: 16px;
}

.show-button-card {
  display: flex;
  background: #fff;
  padding: 10px;
  border-radius: 8px;
  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.1);
  align-items: center;
  width: 85%;
}

.show-button-heading {
  color: #1E1E1E;
  font-family: "Outfit";
  font-weight: 500;
  font-size: 18px;
  padding-bottom: 1rem;
  padding-top: 2rem;
  padding-right: 2rem;
}

.charging-point-chat-message {
  position: relative;
  padding: 12px 16px;
  border-radius: 8px;
  margin: 8px 0;
  max-width: 70%;
  word-wrap: break-word;
}

@media screen and (max-width: 554px) {
  .show-bot-button {
    background-color: #F2F2F2;
    color: #1E1E1E;
    font-size: 14px;
    font-family: "Outfit";
    width: 100%;
    border-radius: 25px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
    margin-top: 10px;
    padding-bottom: 16px;
  }
  .show-button-heading {
    color: #1E1E1E;
    font-family: "Outfit";
    font-weight: 500;
    font-size: 16px;
    padding-bottom: 1rem;
    padding-top: 2rem;
    padding-right: 2rem;
  }
  .show-button-card {
    display: flex;
    background: #fff;
    padding: 10px;
    border-radius: 8px;
    box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.1);
    align-items: center;
    width: 100%;
  }
  .show-bot-button-name {
    color: #1E1E1E;
    font-family: "Outfit";
    font-weight: 500;
    font-size: 12px;
    white-space: nowrap;
    padding-bottom: 1rem;
    padding-right: 1rem;
  }
  .charging-point-chat-message {
    position: relative;
    border-radius: 8px;
    margin: 8px 0;
    max-width: 88%;
    word-wrap: break-word;
  }
}`, "",{"version":3,"sources":["webpack://./src/Pages/ChatBot/ChatBot.scss"],"names":[],"mappings":"AAAA,mBAAA;AASA;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,cAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;AAPJ;;AAUA;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,gBAAA;AAPJ;;AAUA;EACI,aAAA;AAPJ;;AAUA;EACI,WAAA;EACA,YAAA;EACA,kBAAA;AAPJ;;AAUA;EACI,eAAA;EACA,iBAAA;EACA,gBAAA;AAPJ;;AAUA;EACI,WAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;AAPJ;;AAUA;EACI,aAAA;EACA,yBAAA;EACA,yBAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAPJ;;AAYA,yBAAA;AACA;EACI,eAAA;EACA,YAAA;EACA,UAAA;EACA,WAAA;AATJ;;AAYA,mBAAA;AACA;EACI,YAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,6BAAA;EACA,aAAA;EACA,eAAA;EACA,gCAAA;EACA,kBAAA;EACA,mBAAA;AATJ;;AAYA;EACI,cAAA,EAAA,eAAA;EACA,qBAAA;EACA,eAAA;AATJ;;AAYA,iBAAA;AACA;EACI,yBAAA,EAAA,iBAAA;AATJ;;AAYA,eAAA;AACA;EACI,kBAAA;EACA,UAAA,EAAA,uBAAA;EACA,QAAA;EACA,2BAAA;EACA,cAAA,EAAA,eAAA;EACA,eAAA;EACA,eAAA;EACA,kCAAA;AATJ;;AAWA;EACI,kBAAA;EACA,WAAA,EAAA,uBAAA;EACA,QAAA;EACA,2BAAA;EACA,eAAA;AARJ;;AAWA;EACI,gBAAA,EAAA,sBAAA;EACA,aAAA;EACA,+BAAA,EAAA,4CAAA;EACA,uBAAA;EACA,aAAA;EACA,sBAAA;AARJ;;AAWA;EACI,oBAAA;AARJ;;AAWA;EACI,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,cAAA;EACA,qBAAA;AARJ;;AAWA;EACI,oBAAA;EACA,yBAAA;EACA,cAAA;EACA,iBAAA;EACA,qBAAA;EACA,eAAA;EACA,iCAAA;AARJ;;AAWA;EACI,sBAAA;EACA,yBAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;EACA,qBAAA;EACA,YAAA;EACA,iCAAA;AARJ;;AAUA;EACI,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,qBAAA;EACA,yBAAA;AAPJ;;AAWA;EACI,aAAA;EACA,sBAAA;EACA,SAAA;EACA,gBAAA;AARJ;;AAWA;EACI,aAAA;EACA,gBAAA;EACA,aAAA;EACA,kBAAA;EACA,0CAAA;EACA,mBAAA;AARJ;;AAWA;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;AARJ;;AAWA;EACI,YAAA;AARJ;;AAUA;EACI,cAAA;EACA,qBAAA;EACA,gBAAA;EACA,eAAA;EACA,oBAAA;AAPJ;;AAUA;EACI,cAAA;EACA,qBAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,oBAAA;EACA,mBAAA;AAPJ;;AAUA;EACI,cAAA;EACA,qBAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;AAPJ;;AASA;EACI,cAAA;EACA,qBAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;AANJ;;AASA;EACI,iBAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;AANJ;;AAQA;EACI,mBAAA;EACA,mBAAA;AALJ;;AASA;EACI,mBAAA;AANJ;;AASE;EACE,mBAAA;AANJ;;AASE;EACE,WAAA;AANJ;;AASE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;AANJ;;AASE;EACE,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,OAAA;AANJ;;AASE;EACE,iBAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;AANJ;;AASE;EACE,YAAA;AANJ;;AASA;EACI,yBAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;EACA,qBAAA;EACA,mBAAA;AANJ;;AASA;EACI,iBAAA;EACA,mBAAA;EACA,aAAA;EACA,0CAAA;EACA,kBAAA;EACA,oBAAA;AANJ;;AASA;EACI,eAAA;EACA,cAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;AANJ;;AASA;EACI,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;EACA,qBAAA;AANJ;;AASA;EACI,YAAA;AANJ;;AASA;EACI,YAAA;AANJ;;AASA;EACI,iBAAA;EACA,oBAAA;AANJ;;AAUA;EACI,aAAA;EACA,QAAA;EACA,eAAA;AAPJ;AASI;EACE,eAAA;EACA,eAAA;EACA,WAAA;AAPN;AASM;EACE,YAAA;AAPR;;AAYA;EACI,eAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;EACA,qBAAA;EACA,cAAA;AATJ;;AAYA;EACI,8FAAA;AATJ;;AAYE;EACE,gGAAA;AATJ;;AAYA;EACI,WAAA;EACA,aAAA;EACA,uBAAA;AATJ;;AAYA;EACI,yBAAA;EACA,cAAA;EACA,eAAA;EACA,qBAAA;EACA,UAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;EACA,oBAAA;AATJ;;AAWA;EACI,aAAA;EACA,gBAAA;EACA,aAAA;EACA,kBAAA;EACA,0CAAA;EACA,mBAAA;EACA,UAAA;AARJ;;AAUA;EACI,cAAA;EACA,qBAAA;EACA,gBAAA;EACA,eAAA;EACA,oBAAA;EACA,iBAAA;EACA,mBAAA;AAPJ;;AAUA;EACI,yBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,YAAA;AAPJ;AAQI;EACA,mBAAA;AANJ;;AASA;EACI,cAAA;EACA,qBAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,oBAAA;EACA,mBAAA;AANJ;;AASA,yBAAA;AACA;EACI,eAAA;EACA,YAAA;EACA,SAAA;EACA,WAAA;AANJ;;AASA;EACI,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AANJ;;AASA;EACI,yBAAA;EACA,cAAA;EACA,eAAA;EACA,qBAAA;EACA,UAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;EACA,oBAAA;AANJ;;AAQA;EACI,aAAA;EACA,gBAAA;EACA,aAAA;EACA,kBAAA;EACA,0CAAA;EACA,mBAAA;EACA,UAAA;AALJ;;AAOA;EACI,cAAA;EACA,qBAAA;EACA,gBAAA;EACA,eAAA;EACA,oBAAA;EACA,iBAAA;EACA,mBAAA;AAJJ;;AAMA;EACI,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,cAAA;EACA,qBAAA;AAHJ;;AAMA;EACI;IACI,yBAAA;IACA,cAAA;IACA,eAAA;IACA,qBAAA;IACA,WAAA;IACA,mBAAA;IACA,aAAA;IACA,sBAAA;IACA,mBAAA;IACA,SAAA;IACA,gBAAA;IACA,oBAAA;EAHN;EAME;IACI,cAAA;IACA,qBAAA;IACA,gBAAA;IACA,eAAA;IACA,oBAAA;IACA,iBAAA;IACA,mBAAA;EAJN;EAOE;IACI,aAAA;IACA,gBAAA;IACA,aAAA;IACA,kBAAA;IACA,0CAAA;IACA,mBAAA;IACA,WAAA;EALN;EAOE;IACI,cAAA;IACJ,qBAAA;IACA,gBAAA;IACA,eAAA;IACA,mBAAA;IACA,oBAAA;IACA,mBAAA;EALF;EAOE;IACI,kBAAA;IACA,kBAAA;IACA,aAAA;IACA,cAAA;IACA,qBAAA;EALN;AACF","sourcesContent":["/* ChatModule.css */\n.chat-container {\n  \n}\n\n.chat-box {\n   \n}\n\n.chat-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    color:#000000;\n    font-weight: 500;\n    margin: 1rem;\n    font-size: 18px;\n}\n\n.chat-avatar {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    margin-top: 20px;\n}\n\n.chat-avatar-wrapper{\n    padding: 1rem;\n}\n\n.chat-avatar img {\n    width: 80px;\n    height: 80px;\n    border-radius: 50%;\n}\n\n.chat-greeting {\n    font-size: 20px;\n    font-weight: bold;\n    margin-top: 10px;\n}\n\n.chat-description {\n    color: gray;\n    font-size: 16px;\n    text-align: center;\n    margin-top: 2rem;\n}\n\n.swiper-slide {\n    padding: 10px;\n    background-color:#FFFFFF;\n    border: 2px solid #F2F2F2;\n    border-radius: 5rem;\n    text-align: center;\n    cursor: pointer;\n    font-size: 14px;\n    font-weight: 500;\n    color: #000000;\n    // box-shadow: 0px 6px 12px rgba(5, 80, 56, 0.8);\n\n}\n\n/* Chat Input Container */\n.chat-input-container {\n    position: fixed;\n    bottom: 20px;\n    left: 20px;\n    right: 20px;\n}\n\n/* Chat Input Box */\n.chat-input {\n    height:6rem;\n    width: 100%;    \n    padding: 12px;\n    border-radius: 50px;\n    background-color: #e5e7eb;\n    border: 2px solid transparent;\n    outline: none;\n    font-size: 14px;\n    transition: all 0.3s ease-in-out;\n    padding-left: 4rem;\n    padding-right: 8rem;\n}\n\n.chat-input::placeholder {\n    color: #8B8B8B;  /* Gray color */\n    font-family: 'Outfit';\n    font-size: 16px\n}\n\n/* Hover Effect */\n.chat-input:hover {\n    border: 2px solid #10b981; /* Green Border */\n}\n\n/* Input Icon */\n.input-icon {\n    position: absolute;\n    left: 15px;  /* Align inside input */\n    top: 50%;\n    transform: translateY(-50%);\n    color: #6b7280;  /* Gray color */\n    font-size: 18px;\n    cursor: pointer;\n    transition: color 0.3s ease-in-out;\n}\n.send-btn{\n    position: absolute;\n    right: 15px;  /* Align inside input */\n    top: 50%;\n    transform: translateY(-50%);\n    cursor: pointer;\n}\n\n.chat-messages {\n    overflow-y: auto; /* Enables scrolling */\n    padding: 10px;\n    max-height: calc(100vh - 120px); /* Adjust based on header and input height */\n    scroll-behavior: smooth;\n    display: flex;\n    flex-direction: column;\n}\n\n.scroll-anchor {\n    padding-bottom: 80px;\n  }  \n\n.chat-message {\n    position: relative;\n    padding: 12px 16px;\n    border-radius: 8px;\n    margin: 8px 0;\n    max-width: 70%;\n    word-wrap: break-word;\n}\n\n.chat-message.user {\n    align-self: flex-end;\n    background-color: #00AA74;\n    color: #FFFFFF;\n    text-align: right;\n    font-family: 'Outfit';\n    font-size: 14px;\n    border-radius: 25px 25px 2px 25px;\n}\n\n.chat-message.bot {\n    align-self: flex-start;\n    background-color: #F2F2F2;\n    color: #1E1E1E;\n    text-align: left;\n    font-size: 14px;\n    font-family: 'Outfit';\n    width:500px;\n    border-radius: 25px 29px 25px 2px;\n}\n.station-wrapper {\n    position: relative;\n    padding: 12px 16px;\n    border-radius: 8px;\n    margin: 8px 0;\n    word-wrap: break-word;\n    background-color: #F2F2F2;\n\n}\n\n.station-list {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n    margin-top: 10px;\n}\n\n.station-card {\n    display: flex;\n    background: #fff;\n    padding: 10px;\n    border-radius: 8px;\n    box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.1);\n    align-items: center;\n}\n\n.station-image {\n    width: 50px;\n    height: 50px;\n    border-radius: 5px;\n    margin-right: 10px;\n}\n\n.station-details {\n    flex-grow: 1;\n}\n.station-heading{\n    color:#1E1E1E;\n    font-family: 'Outfit';\n    font-weight: 400;\n    font-size: 14px;\n    padding-bottom: 1rem;\n}\n\n.station-name{\n    color:#1E1E1E;\n    font-family: 'Outfit';\n    font-weight: 400;\n    font-size: 14px;\n    white-space: nowrap;\n    padding-bottom: 1rem;\n    padding-right: 1rem;\n}\n\n.station-session{\n    color:#8C8C8C;\n    font-family: 'Outfit';\n    font-weight: 400;\n    font-size: 12px;\n    padding-right: 2rem;\n}\n.selected-station-session{\n    color:#8C8C8C;\n    font-family: 'Outfit';\n    font-weight: 400;\n    font-size: 12px;\n    padding-right: 3rem;\n}\n\n.station-rating {\n    background: green;\n    color: white;\n    padding: 3px 6px;\n    border-radius: 4px;\n    font-size: 12px;\n}\n.payment-container {\n    background: #f5f5f5; \n    border-radius: 12px;\n    // margin-top: 10px;\n}\n\n.payment-container {\n    margin-bottom: 20px; \n  }\n  \n  .payment-card {\n    margin-bottom: 16px;\n  }\n  \n  .refund-ids-container {\n    width: 100%;\n  }\n  \n  .refund-id-row {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 8px;\n    padding: 8px;\n    background-color: #f5f5f5;\n    border-radius: 4px;\n    margin-top: 5px;\n  }\n  \n  .refund-id {\n    text-align: left;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    flex: 1;\n  }\n  \n  .copy-icon {\n    margin-left: 10px;\n    cursor: pointer;\n    width: 18px;\n    height: 18px;\n  }\n  \n  .copy-icon:hover {\n    opacity: 0.7;\n  }\n\n.payment-header {\n    background-color: #F2F2F2;\n    color: #1E1E1E;\n    text-align: left;\n    font-size: 14px;\n    font-family: 'Outfit';\n    margin-bottom: 16px;\n}\n\n.payment-card {\n    background: white;\n    border-radius: 12px;\n    padding: 15px;\n    box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.1);\n    text-align: center;\n    padding-bottom: 1rem;\n}\n\n.payment-title {\n    font-size: 14px;\n    color: #8C8C8C;\n    margin-bottom: 11px;\n    font-family: 'Syne';\n    font-weight: 700;\n    font-size: 14px;\n}\n\n.payment-amount {\n    font-size: 24px;\n    font-weight: 500;\n    margin-bottom: 14px;\n    color: #1E1E1E;\n    font-family: 'Outfit';\n}\n\n.payment-button {\n    height:39px;\n}\n\n.payment-button:hover {\n    opacity: 0.9;\n}\n\n.refund-info{\n    padding-top: 1rem;\n    padding-bottom: 1rem;\n\n}\n\n.chat-actions {\n    display: flex;\n    gap: 8px;\n    margin-top: 5px;\n  \n    .icon {\n      font-size: 14px;\n      cursor: pointer;\n      color: gray;\n      \n      &:hover {\n        color: black;\n      }\n    }\n  }\n\n.selected-text {\n    font-size: 14px;\n    color: #FFFFFF;\n    margin-top: 5px;\n    text-align: right;\n    font-family: 'Outfit';\n    font-size: 400;\n}\n\n.liked {\n    filter: invert(48%) sepia(79%) saturate(2476%) hue-rotate(86deg) brightness(90%) contrast(85%);\n  }\n  \n  .disliked {\n    filter: invert(27%) sepia(51%) saturate(7471%) hue-rotate(356deg) brightness(97%) contrast(115%);\n  }  \n\n.bot-button-wrapper{\n    width: 100%;\n    display: flex;\n    justify-content: center;\n}\n\n.bot-button{\n    background-color: #F2F2F2;\n    color: #1E1E1E;\n    font-size: 14px;\n    font-family: 'Outfit';\n    width:80%;\n    border-radius: 25px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 10px;\n    margin-top: 10px;\n    padding-bottom: 16px;\n}\n.button-card{\n    display: flex;\n    background: #fff;\n    padding: 10px;\n    border-radius: 8px;\n    box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.1);\n    align-items: center;\n    width: 85%;\n}\n.button-heading{\n    color:#1E1E1E;\n    font-family: 'Outfit';\n    font-weight: 500;\n    font-size: 18px;\n    padding-bottom: 1rem;\n    padding-top: 2rem;\n    padding-right: 2rem;    \n}\n\n.bot-button-image {\n    background-color: #F2F2F2;\n    width: 31px;\n    height: 31px;\n    border-radius: 5px;\n    margin-right: 10px;\n    padding: 6px;\n    img{\n    object-fit: contain;\n    }\n}\n.bot-button-name{\n    color:#1E1E1E;\n    font-family: 'Outfit';\n    font-weight: 500;\n    font-size: 14px;\n    white-space: nowrap;\n    padding-bottom: 1rem;\n    padding-right: 1rem;\n}\n\n/* Chat Input Container */\n.swiper-container {\n    position: fixed;\n    bottom: 99px;\n    left: 2px;\n    right: 20px;\n}\n\n.swiper-slide.swiper-style {\n    height: auto;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.show-bot-button{\n    background-color: #F2F2F2;\n    color: #1E1E1E;\n    font-size: 14px;\n    font-family: 'Outfit';\n    width:80%;\n    border-radius: 25px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 10px;\n    margin-top: 10px;\n    padding-bottom: 16px;\n}\n.show-button-card{\n    display: flex;\n    background: #fff;\n    padding: 10px;\n    border-radius: 8px;\n    box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.1);\n    align-items: center;\n    width: 85%;\n}\n.show-button-heading{\n    color:#1E1E1E;\n    font-family: 'Outfit';\n    font-weight: 500;\n    font-size: 18px;\n    padding-bottom: 1rem;\n    padding-top: 2rem;\n    padding-right: 2rem;    \n}\n.charging-point-chat-message {\n    position: relative;\n    padding: 12px 16px;\n    border-radius: 8px;\n    margin: 8px 0;\n    max-width: 70%;\n    word-wrap: break-word;\n}\n\n@media screen and (max-width: 554px) {\n    .show-bot-button {\n        background-color: #F2F2F2;\n        color: #1E1E1E;\n        font-size: 14px;\n        font-family: 'Outfit';\n        width:100%;\n        border-radius: 25px;\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        gap: 10px;\n        margin-top: 10px;\n        padding-bottom: 16px;    \n    }\n\n    .show-button-heading {\n        color: #1E1E1E;\n        font-family: \"Outfit\";\n        font-weight: 500;\n        font-size: 16px;\n        padding-bottom: 1rem;\n        padding-top: 2rem;\n        padding-right: 2rem;\n    }\n\n    .show-button-card {\n        display: flex;\n        background: #fff;\n        padding: 10px;\n        border-radius: 8px;\n        box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.1);\n        align-items: center;\n        width: 100%;\n    }\n    .show-bot-button-name{\n        color:#1E1E1E;\n    font-family: 'Outfit';\n    font-weight: 500;\n    font-size: 12px;\n    white-space: nowrap;\n    padding-bottom: 1rem;\n    padding-right: 1rem;\n    }\n    .charging-point-chat-message {\n        position: relative;\n        border-radius: 8px;\n        margin: 8px 0;\n        max-width: 88%;\n        word-wrap: break-word;\n    }\n}\n\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
